export default class TaxesService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllTaxOffices(args) {
    return this.axiosIns.get(this.serviceConfig.taxOffices, { params: args });
  }
}
